module.exports = __webpack_public_path__ + "img/camera-border.8b99ded9.png";